const SAVOURY = 'savoury';
const SWEET = 'sweet';
const BASIC = 'basic';
const NINJA = 'ninja';

export { SAVOURY, SWEET, BASIC, NINJA };
